export default {
  hover: '#C2EFF5',
  warning: '#ff9800',
  error: '#f44336',
  success: '#4caf50',
  main: '#00BCD4',
  tableOddBg: '#f8f9f9',
  unknown: '#BDBDBD',
  medium: '#F7D617',
  normal: 'rgba(0, 0, 0, 0.54)',
  successBgColor: `rgba(76,175,80,0.2)`,
  errorBgColor: `rgba(244,67,54,0.2)`,
  disabledBgColor: '#E0E0E0'
};
